import { render, staticRenderFns } from "./UserBackgroundCheck.vue?vue&type=template&id=59a4ac2a&"
import script from "./UserBackgroundCheck.vue?vue&type=script&lang=js&"
export * from "./UserBackgroundCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports